import { render, staticRenderFns } from "./AddExpenseLabelModal.vue?vue&type=template&id=d624e6aa&scoped=true&class=fill-height&"
import script from "./AddExpenseLabelModal.vue?vue&type=script&lang=ts&"
export * from "./AddExpenseLabelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d624e6aa",
  null
  
)

export default component.exports